import { defineMessages } from 'react-intl'

export default defineMessages({
  covidHeaderTitle: {
    id: 'home.covid-alert-banner.title',
    defaultMessage: 'Universe takes the well-being of our hosts and attendees seriously',
  },
  covidContentText: {
    id: 'home.covid-alert-banner.content',
    defaultMessage: 'If you are concerned about Coronavirus COVID-19 and would like to make changes to an event you are organizing, or request a refund to an event you are scheduled to attend, please refer to the following articles for instructions.', // eslint-disable-line max-len
  },
  covidLearnMore: {
    id: 'home.covid-alert-banner.learn-more',
    defaultMessage: 'Learn More',
  },
})
